import React from "react"
import { Button } from "semantic-ui-react"
import { useTranslation } from "react-i18next"
import { getVehicleClassfiedData } from "../../helpers/vehicleHelpers"
import { ACTIVE, DEACTIVE } from "../../constants/vehicles"

const BulkActivateDeactivate = ({
  vehicles,
  handleVehicleActivation,
  isBulkApiInProgress,
  checkedVehicles
}) => {
  const { t } = useTranslation("vehicle")

  const filteredVehicles = vehicles.filter((vehicle) => [...checkedVehicles].includes(vehicle.id))

  const { activeVehicle, deactiveVehicle } = getVehicleData(filteredVehicles)

  return (
    <div className="bulk__active-deactive">
      <p className="vehicle__selected">
        {filteredVehicles.length} {t("selected")}
      </p>
      <Button
        onClick={() => handleVehicleActivation(ACTIVE)}
        disabled={deactiveVehicle.length === 0 || isBulkApiInProgress}
        className="vehicle__active"
      >
        {t("active")} ({deactiveVehicle.length})
      </Button>
      <Button
        onClick={() => handleVehicleActivation(DEACTIVE)}
        disabled={activeVehicle.length === 0 || isBulkApiInProgress}
        className="vehicle__deactive"
      >
        {t("deactivate")} ({activeVehicle.length})
      </Button>
    </div>
  )
}

const getVehicleData = (vehicles) => {
  const activeVehicle =
    vehicles && vehicles.length > 0 ? vehicles.filter((vehicle) => vehicle.is_active) : []

  const deactiveVehicle =
    vehicles && vehicles.length > 0 ? vehicles.filter((vehicle) => !vehicle.is_active) : []

  return { activeVehicle, deactiveVehicle }
}

export default BulkActivateDeactivate
